<div class="background-container">
  <div class="message-container">
    <div class="auto-update-message">
      <h3>Manual update is enabled</h3>
      <span>{{ description }}</span>
      <div class="button-bar">
        <capra-button
          variant="secondary"
          color="neutral"
          [text]="isRendered ? 'Apply' : 'Load'"
          (click)="doUpdate()"
        ></capra-button>
        <capra-button
          [text]="isRendered ? 'Apply & switch to automatic' : 'Load & switch to automatic'"
          (click)="doAutomatic()"
        ></capra-button>
      </div>
    </div>
  </div>
</div>
